import styled, { css } from 'styled-components';

export const WeekAndDayEventWrapper = styled.div<{ $isSpeaker: boolean }>`
  display: flex;
  min-height: 48px;
  height: 100%;
  padding: 4px 6px 4px 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  color: ${({ theme }) => theme.colors.black9};
  border-radius: 4px;
  border-left: 4px solid ${({ theme }) => theme.colors.black6};
  background: ${({ theme }) => theme.colors.black1};
  :hover {
    background-color: ${({ theme }) => theme.colors.black2};
  }
  ${({ $isSpeaker }) =>
    $isSpeaker &&
    css`
      border-color: ${({ theme }) => theme.colors.green6};
      background-color: ${({ theme }) => theme.colors.green1};
      :hover {
        background-color: ${({ theme }) => theme.colors.green2};
      }
    `}
`;

export const Title = styled.div`
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;
export const Time = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
`;
